import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { GARAGE, NAV_LINKS } from "../../lib/constants";
import { Logo } from "./Header";

export default function Footer({ catalogueVisible = true }) {
  const liens = catalogueVisible ? NAV_LINKS : NAV_LINKS.filter((l) => l.to !== "/catalogue");
  return (
    <footer className="bg-brand-dark text-white pb-28 lg:pb-0" data-testid="pied-de-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Logo clair />
            <p className="mt-4 font-heading uppercase tracking-[0.2em] text-white/60 text-sm">
              Pneumatiques | Réparations | Mécanique
            </p>
            <p className="mt-4 text-white/70 leading-relaxed">
              Garage indépendant au Cannet depuis plus de 20 ans. Sans rendez-vous :
              passez directement à l'atelier.
            </p>
          </div>
          <div>
            <h3 className="font-heading font-semibold uppercase tracking-wider text-lg text-white mb-4">
              Nous trouver
            </h3>
            <ul className="space-y-3 text-white/80">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-brand-red mt-0.5 shrink-0" aria-hidden="true" />
                <span>{GARAGE.adresse}</span>
              </li>
              <li>
                <a
                  data-testid="footer-telephone"
                  href={`tel:${GARAGE.telephoneLien}`}
                  className="flex items-center gap-3 hover:text-brand-red transition-colors"
                >
                  <Phone size={18} className="text-brand-red shrink-0" aria-hidden="true" />
                  {GARAGE.telephone}
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-email"
                  href={`mailto:${GARAGE.email}`}
                  className="flex items-center gap-3 hover:text-brand-red transition-colors break-all"
                >
                  <Mail size={18} className="text-brand-red shrink-0" aria-hidden="true" />
                  {GARAGE.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Clock size={18} className="text-brand-red mt-0.5 shrink-0" aria-hidden="true" />
                <span>{GARAGE.horairesTexte}</span>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="font-heading font-semibold uppercase tracking-wider text-lg text-white mb-4">
              Le site
            </h3>
            <ul className="space-y-2.5">
              {liens.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-white/80 hover:text-brand-red transition-colors font-body"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/mentions-legales"
                  data-testid="footer-mentions-legales"
                  className="text-white/80 hover:text-brand-red transition-colors font-body"
                >
                  Mentions légales &amp; confidentialité
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-sm text-white/50">
          <p>© {new Date().getFullYear()} Promo Pneus — Le Cannet. Tous droits réservés.</p>
          <p>SIRET 894 128 289 00010</p>
        </div>
      </div>
    </footer>
  );
}
